import { LandingSvg, landingImages } from 'assets';

export const DESKTOP = 1200;
export const MOBILE = 735;

export const powerfulFeaturesCardData = {
    practiceManagement: [
        {
            Icon: LandingSvg.ScheduleSvg,
            iconColor:
                'brightness(0) saturate(100%) invert(62%) sepia(57%) saturate(2612%) hue-rotate(190deg) brightness(96%) contrast(93%)',
            iconHoverColor:
                'brightness(0) saturate(100%) invert(85%) sepia(7%) saturate(2624%) hue-rotate(184deg) brightness(98%) contrast(96%)',
            hoverColor: '#0948A1',
            featureTitle: 'Scheduling',
            featureDescription: 'Automated staff assignments and appointments with real-time availability',
            navigatePath:'/practice#smart-scheduling'
        },
        {
            Icon: LandingSvg.BillingSvg,
            iconColor:
                'brightness(0) saturate(100%) invert(62%) sepia(57%) saturate(2612%) hue-rotate(190deg) brightness(96%) contrast(93%)',
            iconHoverColor:
                'brightness(0) saturate(100%) invert(85%) sepia(7%) saturate(2624%) hue-rotate(184deg) brightness(98%) contrast(96%)',
            hoverColor: '#0948A1',
            featureTitle: 'Billing/Claims',
            featureDescription:
                'Seamless claims management and insurance billing, reducing manual errors',
            navigatePath:'/practice#automated-billing'
        },
        {
            Icon: LandingSvg.PayrollPSvg,
            iconColor: 'brightness(0) saturate(100%) invert(62%) sepia(57%) saturate(2612%) hue-rotate(190deg) brightness(96%) contrast(93%)',
            iconHoverColor: 'brightness(0) saturate(100%) invert(85%) sepia(7%) saturate(2624%) hue-rotate(184deg) brightness(98%) contrast(96%)',
            hoverColor: '#0948A1',
            featureTitle: 'Payroll',
            featureDescription: 'Simplify staff payments with accurate, automated payroll processing.',
            navigatePath:'/practice#timesheets'
        },
        {
            Icon: LandingSvg.ReportingPSVG,
            iconColor: 'brightness(0) saturate(100%) invert(62%) sepia(57%) saturate(2612%) hue-rotate(190deg) brightness(96%) contrast(93%)',
            iconHoverColor: 'brightness(0) saturate(100%) invert(85%) sepia(7%) saturate(2624%) hue-rotate(184deg) brightness(98%) contrast(96%)',
            hoverColor: '#0948A1',
            featureTitle: 'Reporting',
            featureDescription: 'In-depth insights into practice performance with customizable reports',
            navigatePath:'/practice#custom-reporting'
        },
    ],

    dataCollection: [
        {
            Icon: LandingSvg.RealTimePSVG,
            iconColor: 'brightness(0) saturate(100%) invert(70%) sepia(49%) saturate(3168%) hue-rotate(211deg) brightness(100%) contrast(94%)',
            iconHoverColor: 'brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(1%) hue-rotate(140deg) brightness(101%) contrast(101%)',
            hoverColor: '#6941C6',
            featureTitle: 'Real-Time Data',
            featureDescription: 'Collect and sync session data instantly across web and mobile-no delays, no refreshes',
            navigatePath:'/data-collection#real-time-data'
        },
        {
            Icon: LandingSvg.ProgramsPSVG,
            iconColor: 'brightness(0) saturate(100%) invert(70%) sepia(49%) saturate(3168%) hue-rotate(211deg) brightness(100%) contrast(94%)',
            iconHoverColor: 'brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(1%) hue-rotate(140deg) brightness(101%) contrast(101%)',
            hoverColor: '#6941C6',
            featureTitle: 'Programs & Templates',
            featureDescription: 'Create flexible ABA programs with reusable templates, targets, and mastery criteria',
            navigatePath:'/data-collection#custom-programs'
        },
        {
            Icon: LandingSvg.SessionNotesPSVG,
            iconColor: 'brightness(0) saturate(100%) invert(70%) sepia(49%) saturate(3168%) hue-rotate(211deg) brightness(100%) contrast(94%)',
            iconHoverColor: 'brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(1%) hue-rotate(140deg) brightness(101%) contrast(101%)',
            hoverColor: '#6941C6',
            featureTitle: 'Session Notes',
            featureDescription: 'Complete session notes and signatures directly in your workflow-fast and frictionless',
            navigatePath:'/data-collection#integrated-session-notes'
        },
        {
            Icon: LandingSvg.GraphsPSVG,
            iconColor: 'brightness(0) saturate(100%) invert(70%) sepia(49%) saturate(3168%) hue-rotate(211deg) brightness(100%) contrast(94%)',
            iconHoverColor: 'brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(1%) hue-rotate(140deg) brightness(101%) contrast(101%)',
            hoverColor: '#6941C6',
            featureTitle: 'Graphs & Reports',
            featureDescription: 'Automatically visualize progress with clear, up-to-date graphs and reports',
            navigatePath:'/data-collection#automated-graphing'
        },
    ],
};

export const revenueCardsData = [
    {
        Svg: LandingSvg.FasterSvg,
        title: 'Faster Payments',
        description: 'Reduce delays with clean claim submission and proactive follow-up',
    },
    {
        Svg: LandingSvg.FewerSvg,
        title: 'Fewer Denials',
        description: 'Our team identifies and corrects errors before payers reject claims',
    },
    {
        Svg: LandingSvg.FinancialSvg,
        title: 'Full Financial Visibility',
        description: 'Clear insight into billed, pending, and paid claims',
    },
    {
        Svg: LandingSvg.StressFreeSvg,
        title: 'Stress-Free Billing',
        description: 'We handle the workload so your practice stays revenue-healthy',
    },
];

export const customersTestimonials = [
    // {
    //     // customerAvatar: landingImages.customerOne,
    //     customerComment:
    //         'Switching to TherapyLake has been a game-changer for our practice. Our billing is automated, scheduling is seamless, and our data is more organized than ever.',
    //     customerName: 'George J',
    //     customerProfession: 'Practice Manager',
    //     rating: 5,
    // },
    // {
    //     // customerAvatar: landingImages.customerTwo,
    //     customerComment:
    //         'TherapyLake has revolutionized how I manage my caseload as a BCBA. ' +
    //         'The advanced reporting and EMR features have streamlined data collection and analysis, allowing me to focus more on client progress than paperwork.',
    //     customerName: 'Robert S.R',
    //     customerProfession: 'Board Certified Behavioral Analyst',
    //     rating: 5,
    // },
    {
        customerComment: 'TherapyLake has been incredibly easy to implement, and our efficiency in scheduling and billing has improved significantly. It’s truly become our go-to tool!',
        customerName: 'Aisha Khan',
        customerProfession: 'Clinic Administrator',
        rating: 5,
    },
    {
        customerComment: "The session tracking is very helpful, and it's so easy to pull up client notes whenever needed. Overall, a reliable and efficient system.",
        customerName: 'Carlos Rodríguez',
        customerProfession: 'Lead Therapist',
        rating: 5,
    },
    {
        customerComment: 'TherapyLake has made our claims submission smoother than ever before. It integrates seamlessly with our insurance payers, making billing a breeze.',
        customerName: 'Mei Wong',
        customerProfession: 'Billing Specialist',
        rating: 5,
    },
    {
        customerComment: 'The dashboard layout is clean and easy to navigate, and the reporting features provide exactly what we need to keep our clinic running smoothly.',
        customerName: 'Dmitry Ivanov',
        customerProfession: 'Operations Manager',
        rating: 5,
    },
    {
        customerComment: 'Payroll tracking has become simpler for our staff, and we no longer have to worry about errors. The scheduling features are also very intuitive.',
        customerName: 'Priya Patel',
        customerProfession: 'ABA Clinic Director',
        rating: 5,
    },
    {
        customerComment: 'TherapyLake’s role management features are fantastic. Setting up permissions is straightforward, making onboarding new staff much easier.',
        customerName: 'Maria Garcia',
        customerProfession: 'Staff Coordinator',
        rating: 5,
    },
    {
        customerComment: 'The scheduling system is extremely user-friendly. I can see all my appointments in one place, and even rescheduling takes just a few clicks.',
        customerName: 'Yuki Tanaka',
        customerProfession: 'Therapist',
        rating: 5,
    },
    {
        customerComment: 'The guardrails in TherapyLake’s processes have been a huge help in reducing staff errors. From invoicing to claims, every step is guided, making sure we do things right.',
        customerName: 'Ahmed El-Sayed',
        customerProfession: 'Financial Administrator',
        rating: 5,
    },
    {
        customerComment: 'Keeping track of staff credentials is effortless with TherapyLake. Renewing licenses and certifications is now much easier to manage.',
        customerName: 'Anika Müller',
        customerProfession: 'HR Manager',
        rating: 5,
    },
    {
        customerComment: 'TherapyLake has been a game-changer for our clinic. Whether it’s scheduling or managing client information, everything is more organized now.',
        customerName: 'Lucas Fernandes',
        customerProfession: 'Clinic Owner',
        rating: 5,
    },
    {
        customerComment: 'TherapyLake has significantly reduced our administrative workload. From billing to scheduling, all our needs are met with one comprehensive system.',
        customerName: 'Saanvi Reddy',
        customerProfession: 'Office Manager',
        rating: 5,
    },
];

// home-fifth-box-content
export const homeFifthBoxContentTitle = 'See for yourself how we are helping teams do their best work!';

export const homeFifthBoxContentSubtitle =
    'Imagine you have scheduled lore Epsom Here are many variations of passages of Lorem Ipsum available.';

export const cardsData = [
    {
        id: 1,
        title: 'Data Integrity',
        description: 'Checks and balances to avoid scheduling, billing, and data entry errors',
        image: landingImages.whyTherapyCard1,
    },
    {
        id: 2,
        title: 'State of the Art System',
        description: 'Modern, intuitive and robust technology that simplifies usage cuts training times and increases',
        image: landingImages.whyTherapyCard2,
    },
    {
        id: 3,
        title: '24/7 Support',
        description: 'Backed by experts in ABA and modern technology with 24/7 phone/email support',
        image: landingImages.whyTherapyCard3,
    },
    {
        id: 4,
        title: 'Automated Workflows',
        description: 'Reduce manual work and increase efficiency',
        image: landingImages.whyTherapyCard4,
    },
];

export const accessKeyLanding = [
    {
        title: 'Online & Offline Access',
        description: 'Collect data or manage sessions without an internet connection and sync data automatically reconnected',
    },
    {
        title: 'Real-Time Updates',
        description: 'Ensure all client data, schedules, and reports are up-to-date across devices',
    },
    {
        title: 'Quick Data Collection',
        description: 'Record targets, behaviors, and session notes right from your phone with intuitive, mobile-first workflows',
    },
    {
        title: 'Smart Scheduling',
        description: 'View, edit, and manage appointments - complete with automated updates and notifications',
    },
    {
        title: 'Instant Progress Insights',
        description: 'See progress graphs, mastery trends, and client performance snapshots on the go',
    },
];
